module.exports = __webpack_public_path__ + "img/nona.12d824a4.png";